export default __webpack_public_path__ + "static/media/NOBODI_banner.07634c52.png";